// src/pages/business-not-found/index.jsx
import React from "react";
import { useTranslation } from "react-i18next";

export default function BusinessNotFoundPage() {
  const { t } = useTranslation();
  const host = typeof window !== "undefined" ? window.location.hostname : "";

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="max-w-md w-full bg-white shadow rounded-xl px-6 py-5 text-center">
        <div className="text-xs font-medium tracking-wide text-slate-500 uppercase mb-2">
          AppointIQ
        </div>
        <h1 className="text-lg font-semibold mb-2">{t("businessNotFound.title")}</h1>
        <p className="text-sm text-slate-600 mb-4">
          {t("businessNotFound.notFoundFor")}{" "}
          <span className="font-medium text-slate-900">{host || t("businessNotFound.unknown")}</span>.
          <br />
          {t("businessNotFound.checkLink")}
        </p>

        <div className="flex flex-col gap-2">
          <a
            href="https://appointiq.ro"
            className="px-4 py-2 rounded-lg text-sm font-medium bg-slate-900 text-white"
          >
            {t("businessNotFound.goToSite")}
          </a>
          <a
            href="/app/login"
            className="px-4 py-2 rounded-lg text-sm font-medium border border-slate-300 text-slate-700"
          >
            Login
          </a>
        </div>
      </div>
    </div>
  );
}
